<template>
    <a-modal
      :width="500"
      :maskClosable="false"
      :keyboard="false"
      :visible="visible"
      @cancel="visible=false"
    >
      <h2 slot="title" style="text-align:center">温馨告知</h2>
      <div slot="footer">
        <a-button @click="handleOk(true)" type="primary">我已阅读并申请陪同</a-button>
        <a-divider type="vertical"></a-divider>
        <a-button @click="handleOk(false)" type="primary">不需要</a-button>
      </div>
      <div>
        <p>为保障年龄偏小的学生顺利完成在线测评，将允许学生在监护人陪同下进行测评。</p>
        <p>您若点击“我已阅读并申请陪同”按钮后，系统将视为您认同以下内容：</p>
        <br>
        <p>一、遵守监考纪律：</p>
        <p>1、全程保持开启视频和音频录制、录屏等监考手段；</p>
        <p>2、禁止参与测评题目相关的任何形式的提示或代操作；</p>
        <p>3、对测评内容进行保密，不拍照不截屏不传播。</p>
        <br>
        <p>二、履行陪同义务：</p>
        <p>1、有能力协助学生调试监考视频和屏幕分享、解决电脑软硬件故障；</p>
        <p>2、必要时，协助学生检查文件是否保存成功等。</p>
        <br>
        <p>作为监护人承诺，若不能履行义务则自动退出陪同。若违反监考纪律，同意将学生成绩按无效处理。</p>
        <br>
        <p>学生若无需陪同，可点击“不需要”后，进入测评。</p>
      </div>
    </a-modal>
</template>
<script>
export default {
  name: "LowAgeConfirmModal",
  data() {
    return {
      visible: false,
      isAgree: false,
      content: '',
    };
  },
  methods: {
    //检查是否为低龄，是返回true并显示确认框
    check(idcard) {
      //this.visible = true;
      if(idcard && idcard.length==18 && this.isLowAge(idcard)){
          this.visible = true
          return true
      }
      return false
    },
    hide(){
      this.visible = false
    },
    handleOk(isAgree){
      this.$emit("ok", isAgree)
      this.visible = false
    },
    //是否低龄
    isLowAge(idcard){
      console.log("idcard", idcard);
      //9岁以下的或9岁且月份小于9的
      let currentYear = new Date().getFullYear()
      let idcardYear = parseInt(idcard.slice(6, 10))
      let idcardMonth = parseInt(idcard.slice(10, 12))
      if(currentYear-idcardYear<9){
        return true
      }else if(currentYear-idcardYear==9 && idcardMonth > 8){
        return true
      }
      return false
    },
  },
};
</script>
<style scoped>
.qrcode {
  width: 100%;
}
</style>